/**
 * Minimal classnames helper. Avoids pulling in `clsx` as a dep.
 * Accepts strings, undefined, false, and string[] (flat).
 */
export function cx(...parts: Array<string | undefined | null | false | 0 | string[]>): string {
  const out: string[] = [];
  for (const p of parts) {
    if (!p) continue;
    if (Array.isArray(p)) out.push(...p.filter(Boolean) as string[]);
    else out.push(p as string);
  }
  return out.join(" ");
}
